import {
  createQuery,
  createSuspenseQuery
} from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

// Define the response schema based on the Swagger specification
const PublicViewEventSchema = z.object({
  resource_id: z.int(),
  resource_label: z.string().min(1).nullish(),
  task_id: z.number(),
  task_name: z.string().min(1).nullish(),
  task_color: z.string().min(1).nullish(),
  task_style: z.string().min(1).nullish(),
  start_time: z.iso.datetime(),
  end_time: z.iso.datetime()
});

type PublicViewEvent = z.infer<typeof PublicViewEventSchema>;
type Response = PublicViewEvent[];

const PublicViewEventsRequestSchema = z.object({
  slug: z.string(),
  id: z.string(),
  start_datetime: z.string(),
  end_datetime: z.string()
});

type Request = z.infer<typeof PublicViewEventsRequestSchema>;

export const usePublicViewEvents = createQuery<Response, Request, Error>({
  queryKey: ["publicViewEvents"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<Request, Response>({
      method: "GET",
      url: `/public/:slug/boardviews/:id/events`,
      requestSchema: PublicViewEventsRequestSchema,
      responseSchema: z.array(PublicViewEventSchema),
      body: variables
    });
  }
});

export const usePublicViewEventsWithSuspense = createSuspenseQuery<
  Response,
  Request,
  Error
>({
  queryKey: ["publicViewEvents"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<Request, Response>({
      method: "GET",
      url: `/public/:slug/boardviews/:id/events`,
      requestSchema: PublicViewEventsRequestSchema,
      responseSchema: z.array(PublicViewEventSchema),
      body: variables
    });
  }
});
